import React from 'react';
import styles from './HomeThird.module.css';
import communication from '../../assets/images/communication.svg';
import secure from '../../assets/images/secure.svg';
import customer from '../../assets/images/customer support.svg';
import progress from '../../assets/images/progress.svg';
import { Link } from 'react-router-dom';


const data = [
    {
        name:"Easy to use",
        image:communication,
        det:"Easy, contactless application process. Upload documents, pay and get your visa on mail. It's that simple"
    },
    {
        name:"Reliable support",
        image:customer,
        det:"Easy, contactless application process. Upload documents, pay and get your visa on mail. It's that simple"

    },
    {
        name:"Track visa process",
        image:progress,
        det:"Easy, contactless application process. Upload documents, pay and get your visa on mail. It's that simple"
    },
    {
        name:"Secure payment",
        image:secure,
        det:"Easy, contactless application process. Upload documents, pay and get your visa on mail. It's that simple"
    },
]

export default function HomeThird() {
    return (
        <div className={styles.main}>
            <h1 className={styles.heading}>Why use Visapro</h1>
            <p className={styles.pera}>Our visa application is very simple and seamless.</p>
            <div className={styles.cards}>
                {data.map((value, index)=>(
                    <div className={styles.card} key={index}>
                        <img src={value.image} alt={value.name} className={styles.image} />
                        <div>
                        <h1 className={styles.name}>{value.name}</h1>
                        <p className={styles.det}>{value.det}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.center}>
            <Link to="/dashboard/plan-a-trip">
                <button className={styles.button}>Apply Now</button>
            </Link>
            </div>
        </div>
    )
}
